var map = {
	"./WHOGuidingPrincipe.png": 4211,
	"./client-1.png": 11,
	"./client-2.png": 1680,
	"./client-3.png": 2857,
	"./client-4.png": 6678,
	"./client-5.png": 3007,
	"./client-6.png": 8356,
	"./logo-epf.png": 5869,
	"./who_logo_small.png": 6150
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2470;